import { auth0 } from './auth'
import { store } from './store'

import { ApolloClient, createHttpLink, InMemoryCache, defaultDataIdFromObject, from } from '@apollo/client/core'
import { createApolloProvider } from '@vue/apollo-option'
import { provideApolloClients } from '@vue/apollo-composable'
import { setContext } from '@apollo/client/link/context'
import VueApolloComponents from '@vue/apollo-components'

// HTTP connexion to the API
const httpLink = new createHttpLink({
  // You should use an absolute URL here
  uri: import.meta.env.VITE_APP_GRAPHQL_HTTP
})

const authLink = setContext(async (_, { headers }) => {
  // console.log('[Apollo] Starting token retrieval...')
  try {
    const token = await auth0.getAccessTokenSilently()
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : ''
      }
    }
  } catch (err) {
    console.error('[Apollo] Token retrieval failed:', err)
    return { headers }
  }
})

// Cache implementation
const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Participant': return `Participant:${object.Participant_SK}`
      case 'Benefit': return `Benefit:${object.Benefit_SK}`
      case 'Brand': return `Brand:${object.Brand_SK}`
      case 'Category': return `Category:${object.Category_SK}`
      case 'Company': return `Company:${object.Company_SK}`
      case 'House': return `House:${object.House_SK}`
      case 'Line': return `Line:${object.Line_SK}`
      case 'MultiPack': return `MultiPack:${object.Multi_Pack_SK}`
      case 'Product': return `Product:${object.Product_SK}`
      case 'ProductMatching': return `ProductMatching:${object.Product_Matching_SK}`
      case 'LogMutation': return `LogMutation:${object.Log_SK}`
      default: return defaultDataIdFromObject(object) // fall back to default handling
    }
  },
  cacheRedirects: {
    Query: {
      getProduct: (root, args, { getCacheKey }) => getCacheKey({
        __typename: 'Product',
        Product_SK: args.Product_SK
      }),
      // getPOS: (root, args, { getCacheKey }) => getCacheKey({
      //   __typename: 'POS',
      //   POS_SK: args.POS_SK
      // }),
      // getTicket: (root, args, { getCacheKey }) => getCacheKey({
      //   __typename: 'Ticket',
      //   Ticket_SK: args.Ticket_SK
      // })
    }
    // Doesn't work.. not even executed :(
    // Source: {
    //   ProcessPart: (src, args, { getCacheKey }) => {
    //     console.log(src)
    //     return getCacheKey({
    //       __typename: 'ProcessPart',
    //       Process_Part_ID: src.Process_Part_FK
    //     })
    //   }
    // }
  }
})

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache
})

export const apolloProvider = new createApolloProvider({
  defaultClient: apolloClient,
  errorHandler (error) {
    store.commit('addError', error.message)
    console.log(error)
  }
})

provideApolloClients({ default: apolloClient })

export { VueApolloComponents }
